import React from 'react'

const MedicineInventory = () => {
  return (
    <div>MedicineInventory</div>
  )
}

export default MedicineInventory